angular.module('app').directive("uploadJson", [
    '$rootScope', '$timeout', 'logger',
    function ($rootScope, $timeout, logger) {
        return {
            restrict: "A",
            link: function (scope, element, attributes) {
                element.bind("change", function (changeEvent) {
                    var reader = new FileReader();
                    reader.onload = function (loadEvent) {
                        $timeout(
                            function () {
                                scope.$apply(function () {
                                    try {
                                        var uploadedJson = JSON.parse(loadEvent.target.result);
                                        $rootScope.$broadcast("json:uploaded", uploadedJson, loadEvent.target.result);
                                    } catch(ex) {
                                        logger.logError("global.invalidJsonFile");
                                    }


                                });
                            }
                        );

                        /*scope.$digest(scope.uploadFile = loadEvent.target.result)*/
                    };

                    reader.readAsText(changeEvent.target.files[0]);
                    changeEvent.target.value = "";
                });
            }
        }
    }]);
